import PageHeader from "@/components/PageHeader";
import Tags from "@/components/Tags";

export interface Artist {
  id: number;
  name: string;
  created_at: Date;
}

interface Props {
  artist: Artist;
  contributor_names: string[];
}

const Show: React.FC<Props> = ({ artist, contributor_names }) => {
  return (
    <div className="flex w-full flex-col items-start justify-start gap-5 md:gap-10">
      <PageHeader
        backLink={{ href: "/artists", text: "Back to all artists" }}
        title={artist.name}
        primaryAction={{ href: `/artists/${artist.id}/edit`, text: "Edit" }}
      />
      <div className="flex w-full flex-col">
        <div className="rounded-2xl bg-white p-6 shadow dark:bg-black">
          <dl className="grid grid-cols-1 gap-4">
            <div>
              <dt className="font-semibold text-cream-800 dark:text-cream-200">
                Contributors
              </dt>
              <dd className="mt-1">
                {contributor_names.length > 0 ? (
                  <Tags tags={contributor_names} />
                ) : (
                  <span className="text-cream-600 dark:text-cream-400">-</span>
                )}
              </dd>
            </div>
            <div>
              <dt className="font-semibold text-cream-800 dark:text-cream-200">
                Created At
              </dt>
              <dd className="mt-1 text-cream-600 dark:text-cream-400">
                {new Date(artist.created_at).toLocaleDateString()}
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
};

export default Show;
